import React, { useState, useRef, useEffect } from "react";
import style from "./exceptionCard.module.scss"
import Input from "../../input/input"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { Link } from "react-router-dom";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas";

const ExceptionCard = (props) => {

    const [selectedTimeRange, setSelectedTimeRange] = useState({
        DKPC: '',
        specificPricingRange: '',
        totalTime: 0,
        totalPrice: 0,
        timeError: '',
        DKPCError: ''
    })
    const [isEditing, setIsEditing] = useState(false)


    useEffect(async () => {
        let tmp = selectedTimeRange;
        if (props.data.specificPricingRange && props.data.DKPC) {
            tmp.DKPC = props.data.DKPC
            tmp.specificPricingRange = props.data.specificPricingRange
            tmp.totalTime = (43200 / props.data.specificPricingRange)
            tmp.totalPrice = (43200 / props.data.specificPricingRange) * (props.perPrice)
        } else {
            tmp.DKPC = ''
            tmp.specificPricingRange = ''
            tmp.totalTime = 0
            tmp.totalPrice = 0
        }
        setSelectedTimeRange({ ...tmp })
    }, [props.data]);

    const determineInvoice = () => {
        let times = toEnglishNumber(selectedTimeRange.specificPricingRange.toString()) && toEnglishNumber(selectedTimeRange.specificPricingRange.toString()) != 0 ? (43200 / toEnglishNumber(selectedTimeRange.specificPricingRange.toString())) : 0;
        let price = toEnglishNumber(selectedTimeRange.specificPricingRange.toString()) && props.perPrice && toEnglishNumber(selectedTimeRange.specificPricingRange.toString()) != 0 ? times * (props.perPrice) : 0

        let tmp = selectedTimeRange;
        tmp.totalTime = times
        tmp.totalPrice = price
        setSelectedTimeRange({ ...tmp })
    }

    const handleTimeRangeChange = (tag, value) => {
        setIsEditing(true)
        let tmp = selectedTimeRange
        if (tag == 'specificPricingRange' && (Number(toEnglishNumber(value.target.value)) < 1 || (Number(toEnglishNumber(value.target.value)) % 1 !== 0) || (Number(toEnglishNumber(value.target.value)) > 1440))) {
            tmp.timeError = 'بازه زمانی غیر معتبر است.'
        } else {
            tmp.timeError = ''
        }
        tmp[tag] = value.target.value
        setSelectedTimeRange({ ...tmp })
        if (selectedTimeRange.DKPC && selectedTimeRange.specificPricingRange) {
            determineInvoice()
        }
    }

    const editException = async (type) => {
        let tmp = selectedTimeRange;
        if (type == 'delete') {
            if (tmp.DKPC) {
                tmp.specificPricingRange = null
                await props.editVariant(tmp)
            } else {
                if (!tmp.DKPC) {
                    tmp.DKPCError = 'لطفا کد تنوع را وارد کنید!'
                }
                if (!tmp.specificPricingRange) {
                    tmp.timeError = 'لطفا بازه زمانی مورد نظر را وارد کنید!'
                }
            }
        }
        if (type == 'submit') {
            if (tmp.DKPC && tmp.specificPricingRange && parseFloat(toEnglishNumber(toPersianNumber(tmp.specificPricingRange))) >= 1) {
                await props.editVariant(tmp)
            } else {
                if (!tmp.DKPC) {
                    tmp.DKPCError = 'لطفا کد تنوع را وارد کنید!'
                }
                if (!tmp.specificPricingRange) {
                    tmp.timeError = 'لطفا بازه زمانی مورد نظر را وارد کنید!'
                }
                if (parseFloat(toEnglishNumber(tmp.specificPricingRange)) < 1) {
                    tmp.timeError = 'بازه زمانی غیر معتبر است.'
                }
            }
        }
        if (type == 'cancel') {
            tmp.DKPC = props.DKPC
            tmp.specificPricingRange = props.specificPricingRange
            tmp.DKPCError = ''
            tmp.timeError = ''

            if (!tmp.DKPC || !tmp.specificPricingRange) {
                tmp.totalPrice = 0
                tmp.totalTime = 0
            }
        }
        setSelectedTimeRange({ ...tmp })
        setIsEditing(false)
    }

    return (
        <div className={style.wrapper}>
            <div className={style.itemWrapper}>
                <div className={style.listHeaderFlexItem228}>
                    <Input
                        type="text"
                        disabled={false}
                        label={''}
                        withDKPC={true}
                        placeholder="کد تنوع"
                        error={selectedTimeRange.DKPCError}
                        tag="DKPC"
                        value={selectedTimeRange.DKPC}
                        onchange={handleTimeRangeChange}
                        onblur={() => { }}
                    />
                </div>
                <div className={style.listHeaderFlexItem228}>
                    <Input
                        type="text"
                        disabled={false}
                        label={''}
                        withMinute={true}
                        placeholder="بازه قیمت‌گذاری"
                        error={selectedTimeRange.timeError}
                        tag="specificPricingRange"
                        value={selectedTimeRange.specificPricingRange}
                        onchange={handleTimeRangeChange}
                        onblur={() => { }}
                    />
                </div>
                {/* <div className={style.listHeaderFlexItem124}>
                    {props.perPrice ? toPersianNumber(numberWithCommas(props.perPrice)) : '-'}
                </div> */}
                <div className={style.listHeaderFlexItem124}>
                    {selectedTimeRange.totalTime ? toPersianNumber(numberWithCommas(selectedTimeRange.totalTime)) : '-'}
                </div>
                <div className={style.listHeaderFlexItem124}>
                    {selectedTimeRange.totalPrice ? toPersianNumber(numberWithCommas(selectedTimeRange.totalPrice)) : '-'}
                </div>
                <div className={style.listHeaderFlexItem32}>
                    <div onClick={() => editException('delete')} className={style.trash}></div>
                </div>
                <div className={style.listHeaderFlexItem32}>
                    {isEditing && <div className={style.iconWrapper}>
                        <div onClick={() => editException('submit')} className={style.greenBox}><div className={style.checkIcon}></div></div>
                        <div onClick={() => editException('cancel')} className={style.redBox}>e</div>
                    </div>}
                </div>
            </div>
        </div>
    );
}

export default ExceptionCard;
